import { generateTypes } from '../utils/HttpReducerHelper';

export const declineFundingMatch = generateTypes('FUNDING_MATCH', 'DECLINE_FUNDING_MATCH');
export const acceptLead = generateTypes('FUNDING_MATCH', 'ACCEPT_LEAD');
export const rejectLead = generateTypes('FUNDING_MATCH', 'REJECT_LEAD');
export const OPEN_DECLINE_FUNDING_MATCH_MODAL =
  'platfi-ui-app/FUNDING_MATCH/OPEN_DECLINE_FUNDING_MATCH_MODAL';
export const CLOSE_DECLINE_FUNDING_MATCH_MODAL =
  'platfi-ui-app/FUNDING_MATCH/CLOSE_DECLINE_FUNDING_MATCH_MODAL';

export * from './updateMatchStatusModal/actions';
